import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    console.log('error: ', error);
    console.error('error: ', error);
    const message = error?.message || '';
    const conditionsToReload =
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Importing a module script failed') ||
      message.includes('A ServiceWorker intercepted') ||
      (message.includes('Loading chunk') && message.includes('failed'));
    if (conditionsToReload) {
      console.log('Dynamic import error detected, refreshing page...');
      window.location.reload();
    }
  }
}
